import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import UnitFactory from "../../Entity/Factories/UnitFactory";

export default function* unitList(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "units");

    const units = res.data.data.map(unit => {
      return UnitFactory.create(unit);
    });

    yield put({
      type: Constants.GLOBAL_UNIT_LIST_SUCCESS,
      payload: {
        units: units
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchUnitList() {
  yield takeEvery(Constants.GLOBAL_UNIT_LIST, unitList);
}
